import React, { lazy } from 'react';
import Loadable from '../ui-component/Loadable';

const inputForms = (orgId) => {
    const forms = [];
    console.log(`Loading forms for orgId: ${orgId}`); // Debugging line
    if (orgId === 32) {
        forms.push(
            {
                id: 'preproduction-booking',
                title: 'Cutting Issue Production Booking Form',
                type: 'item',
                url: '/pre-production-booking',
                component: Loadable(lazy(() => import('../views/forms/32/Preproductionbooking')))
            },
            {
                id: 'preproduction2-booking',
                title: 'Production Booking Form',
                type: 'item',
                url: '/pre-production2-booking',
                component: Loadable(lazy(() => import('../views/forms/32/Preproduction2booking')))
            },
            {
                id: 'production-booking',
                title: 'Quality Check Production Booking Form',
                type: 'item',
                url: '/production-booking',
                component: Loadable(lazy(() => import('../views/forms/32/ProductionBooking')))
            },
            {
                id: 'dispatch-form',
                title: 'Dispatch Form',
                type: 'item',
                url: '/dispatch-form',
                component: Loadable(lazy(() => import('../views/forms/32/Dispatchform')))
            },
            {
                id: 'manage-production-stage',
                title: 'Manage Production Stage Form',
                type: 'item',
                url: '/manageprodstage-form',
                component: Loadable(lazy(() => import('../views/forms/32/Manageprodstageform')))
            },
            {
                id: 'delete-booking',
                title: 'Delete Production Booking',
                type: 'item',
                url: '/delete-production',
                component: Loadable(lazy(() => import('../views/forms/32/DeleteProduction')))
            },
        );
    } else if (orgId === 46) {
        forms.push(
            {
                id: 'preproduction3-booking',
                title: 'Pre Production Booking Form',
                type: 'item',
                url: '/pre-production3-booking',
                component: Loadable(lazy(() => import('../views/forms/46/Preproduction3booking')))
            }
        );
    } else if (orgId === 45) {
        forms.push(
            {
                id: 'preproduction-booking',
                title: 'Cutting Issue Production Booking Form',
                type: 'item',
                url: '/pre-production-booking',
                component: Loadable(lazy(() => import('../views/forms/45/Preproductionbooking')))
            },
            {
                id: 'preproduction2-booking',
                title: 'Production Booking Form',
                type: 'item',
                url: '/pre-production2-booking',
                component: Loadable(lazy(() => import('../views/forms/45/Preproduction2booking')))
            },
            {
                id: 'production-booking',
                title: 'Quality Check Production Booking Form',
                type: 'item',
                url: '/production-booking',
                component: Loadable(lazy(() => import('../views/forms/45/ProductionBooking')))
            },
            {
                id: 'dispatch-form',
                title: 'Dispatch Form',
                type: 'item',
                url: '/dispatch-form',
                component: Loadable(lazy(() => import('../views/forms/45/Dispatchform')))
            },
            {
                id: 'manage-production-stage',
                title: 'Manage Production Stage Form',
                type: 'item',
                url: '/manageprodstage-form',
                component: Loadable(lazy(() => import('../views/forms/45/Manageprodstageform')))
            },
            {
                id: 'delete-booking',
                title: 'Delete Production Booking',
                type: 'item',
                url: '/delete-production',
                component: Loadable(lazy(() => import('../views/forms/45/DeleteProduction')))
            },
        );
    } else {
        forms.push(
            {
                id: 'preproduction-booking',
                title: 'Cutting Issue Production Booking Form',
                type: 'item',
                url: '/pre-production-booking',
                component: Loadable(lazy(() => import('../views/forms/45/Preproductionbooking')))
            },
        );
    }

    // Common forms, available for all orgs
    forms.push(
        {
            id: 'pricing',
            title: 'Pricing',
            type: 'item',
            url: '/pricing',
            component: Loadable(lazy(() => import('../views/forms/common/Pricing')))
        },
        {
            id: 'invoice-booking-form',
            title: 'Invoice Booking Form',
            type: 'item',
            url: '/invoice-booking-form',
            component: Loadable(lazy(() => import('../views/forms/common/Invoicebookingform')))
        },
        {
            id: 'part-master-upload',
            title: 'Material Received Form',
            type: 'item',
            url: '/part-master-upload',
            component: Loadable(lazy(() => import('../views/forms/common/PartMasterUpload')))
        },
        {
            id: 'material-issue-form',
            title: 'Material Issue Form',
            type: 'item',
            url: '/material-issue-form',
            component: Loadable(lazy(() => import('../views/forms/common/MaterialIssueForm')))
        }
    );

    return {
        id: 'input-forms',
        title: 'Input Forms',
        type: 'group',
        children: forms
    };
};

export default inputForms;
